// Recovered compiled webpack factory 58607. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "isLocalURL", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(62296),
    a = r(92929);
  function o(e) {
    if (!(0, n.isAbsoluteUrl)(e)) return !0;
    try {
      let t = (0, n.getLocationOrigin)(),
        r = new URL(e, t);
      return r.origin === t && (0, a.hasBasePath)(r.pathname);
    } catch (e) {
      return !1;
    }
  }
}
